/* eslint-disable */
import * as React from "react";
import { ReportToolbar, ReportToolbarGroup, ReportToolbarSpacer, ReportToolbarNumber } from "../../components/ReportToolbar";
import { ReportGrid } from "../../components/ReportGrid";
import { ReportLayout } from "../../components/ReportLayout";
import { ReportHeader } from "../../components/ReportHeader";
import { ReportContainer } from "../../components/ReportContainer";
import { ReportRenderer } from "../../shared";
import { CropsControl } from "./controls/CropsControl";
import { CalendarControl } from "./controls/CalendarControl";
import { CbotDateControl } from "./controls/CbotDateControl";
import { ReferenceYearControl } from "./controls/ReferenceYearControl";

import { useFavourite } from "./favourite/useFavourite";
import { useSlideTitle } from "./hooks/useSlideTitle";
import { useSlideSubtitle } from "./hooks/useSlideSubtitle";
import { SLIDE_NUMBER } from "./constants";

export default function Slide34(props: { exportMode?: boolean }) {
  const { exportMode } = props;

  const title = useSlideTitle();
  const subtitle = useSlideSubtitle();
  useFavourite();

  return (
    <ReportContainer>
      <ReportHeader title={title} subtitle={subtitle} exportMode={exportMode} />
      <ReportToolbar exportMode={exportMode}>
        <ReportToolbarGroup>
          <CalendarControl />
          <CropsControl />
          <ReferenceYearControl />
          <CbotDateControl />
        </ReportToolbarGroup>
        <ReportToolbarSpacer />
        <ReportToolbarNumber number={SLIDE_NUMBER} />
      </ReportToolbar>
      <ReportLayout>
        <ReportGrid>
          <ReportRenderer componentId="chart" />
        </ReportGrid>
      </ReportLayout>
    </ReportContainer>
  );
}
